export const SET_COMPANY_INFO = "SET_COMPANY_INFO";
export const SET_My_COMPANIES_LIST = "SET_My_COMPANIES_LIST";
export const SET_REGIONS_LIST = "SET_REGIONS_LIST";
export const SET_CITIES_LIST = "SET_CITIES_LIST";
export const SET_FAQS_LIST = "SET_FAQS_LIST";
export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
export const SWITCH_CURRENT_LANGUAGE = "SWITCH_CURRENT_LANGUAGE";
